import React, { useEffect, useState } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
  formatterStatus,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import { DropdownCustomToggler } from "../../../_metronic/_partials/dropdowns";

export const ActivityTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // Add number
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
      };
    });
    setTableData(initData);
  }, [data]);

  const [tableData, setTableData] = useState(data);

  const columns = [
    // {
    //   text: "No",
    //   dataField: "no",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   style: { minWidth: "60px" },
    // },
    {
      text: "Activity",
      dataField: "activity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Completed",
      dataField: "completed",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Pending",
      dataField: "pending",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Total Vehicle",
      dataField: "total_Vehicle",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      console.log(row, "row");
      if (row.activity === "RCI") {
        history.push(`/motor-pool/activity-monitor/type`, "RCI");
      }
      if (row.activity === "PDI-In") {
        history.push(`/motor-pool/activity-monitor/type`, "PDI-In");
      }
      if (row.activity === "PDI-Out") {
        history.push(`/motor-pool/activity-monitor/type`, "PDI-Out");
      }
      if (row.activity === "Storage") {
        history.push(`/motor-pool/activity-monitor/type`, "Storage");
      }
      if (row.activity === "Picking") {
        history.push(`/motor-pool/activity-monitor/type`, "Picking");
      }
      if (row.activity === "Handover") {
        history.push(`/motor-pool/activity-monitor/type`, "Handover");
      }
      if (row.activity === "Back To Storage") {
        history.push(`/motor-pool/activity-monitor/type`, "Back To Storage");
      }
      if (row.activity === "Maintenance") {
        history.push(`/motor-pool/activity-monitor/type`, "Maintenance");
      }
      if (row.activity === "Inspection") {
        history.push(`/motor-pool/activity-monitor/type`, "Inspection");
      }
      if (row.activity === "Re PDI-In") {
        history.push(`/motor-pool/activity-monitor/type`, "Re PDI-In");
      }
      if (row.activity === "Re PDI-Out") {
        history.push(`/motor-pool/activity-monitor/type`, "Re PDI-Out");
      }
      if (row.activity === "Vehicle Information Update") {
        history.push(
          `/motor-pool/activity-monitor/type`,
          "Vehicle Information Update"
        );
      }
      if (row.activity === "Count") {
        history.push(`/motor-pool/activity-monitor/type`, "Count");
      }
    },
  };

  return (
    <>
      <BootstrapTable
        // remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="inbound_id"
        data={tableData}
        columns={columns}
        // pagination={paginationFactory(options)}
        // onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
        rowEvents={rowEvents}
        noDataIndication="No data to display.   Please do searching to display particular vehicle(s)"
      >
        {/* <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} /> */}
      </BootstrapTable>
      {/* Footer */}
    </>
  );
};
